export function hasProperty<T>(obj: unknown, property: string): obj is T {
  return !!obj && typeof obj === 'object' && Object.keys(obj)?.includes(property);
}
